/**
 * Mobile Contact Button Handler
 * @package g3w-theme
 * @author Gianito - G3W (Gianito.com)
 * @copyright Copyright (c) Gianito - G3W. Tous droits réservés.
 * @license Proprietary
 */

(function () {
    'use strict';

    /**
     * Initialise les boutons de contact mobile
     */
    function initMobileContactButton() {
        // Vérifier si on est sur mobile (largeur d'écran <= 1272px selon le CSS)
        if (window.innerWidth > 1272) {
            return;
        }

        // Récupérer le container du menu mobile
        const mobileMenuContent = document.querySelector('.wp-block-navigation__responsive-container-content');
        if (!mobileMenuContent) {
            return;
        }

        // Vérifier si les boutons n'ont pas déjà été ajoutés
        if (mobileMenuContent.querySelector('.menu-mobile-buttons')) {
            return;
        }

        // Créer le conteneur pour les boutons mobiles avec la structure wp-block-buttons
        const mobileButtonsContainer = document.createElement('div');
        mobileButtonsContainer.className = 'menu-mobile-buttons wp-block-buttons is-layout-flex wp-block-buttons-is-layout-flex';

        // Créer le bouton "Demander un devis"
        const devisButton = document.createElement('div');
        devisButton.className = 'wp-block-button is-style-btn-solid-red is-style-btn-brush has-icon__chevron-right';
        devisButton.innerHTML = `
            <a class="wp-block-button__link wp-element-button" href="/contact/">
                <svg xmlns="http://www.w3.org/2000/svg" class="wp-block-button__link-icon">
                    <use xlink:href="#chevron-right"></use>
                </svg>
                Demander un devis
            </a>
        `;

        // Créer le bouton téléphone
        const phoneButton = document.createElement('div');
        phoneButton.className = 'wp-block-button is-style-btn-outline is-style-btn-brush-outline has-icon__phone-forwarded';
        phoneButton.innerHTML = `
            <a class="wp-block-button__link wp-element-button" href="tel:0478295111">
                <svg xmlns="http://www.w3.org/2000/svg" class="wp-block-button__link-icon">
                    <use xlink:href="#phone-forwarded"></use>
                </svg>
                04 78 29 51 11
            </a>
        `;

        // Ajouter les boutons au conteneur
        mobileButtonsContainer.appendChild(devisButton);
        mobileButtonsContainer.appendChild(phoneButton);

        // Ajouter le conteneur au menu mobile
        mobileMenuContent.appendChild(mobileButtonsContainer);
    }

    /**
     * Initialise quand le DOM est prêt
     */
    function init() {
        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', initMobileContactButton);
        } else {
            initMobileContactButton();
        }

        // Réinitialiser quand le menu s'ouvre (car WordPress peut recréer le contenu)
        document.addEventListener('click', function (e) {
            if (e.target.matches('.wp-block-navigation__responsive-container-open, .wp-block-navigation__responsive-container-open *')) {
                // Petit délai pour laisser WordPress créer le menu
                setTimeout(initMobileContactButton, 100);
            }
        });

        // Gérer le redimensionnement de l'écran
        let resizeTimeout;
        window.addEventListener('resize', function () {
            clearTimeout(resizeTimeout);
            resizeTimeout = setTimeout(function () {
                // Réinitialiser si on change de taille d'écran
                const existingContainer = document.querySelector('.menu-mobile-buttons');
                if (existingContainer) {
                    existingContainer.remove();
                }
                initMobileContactButton();
            }, 250);
        });
    }

    // Lancer l'initialisation
    init();

})(); 